import React from 'react';
import { Bot, Workflow, Rocket, PenTool, GraduationCap, Sparkles, ArrowUpRight, BrainCircuit, Satellite } from 'lucide-react';
import { AI_FEATURES, AI_PLATFORMS } from '../data/siteData';
import useReveal from '../hooks/useReveal';

const ICONS = { Bot, Workflow, Rocket, PenTool, GraduationCap, BrainCircuit, Satellite };

function AICard({ feature, index }) {
  const ref = useReveal();
  const Icon = ICONS[feature.icon];
  return (
    <article
      ref={ref}
      className={`ai-card reveal ${feature.featured ? 'ai-card-featured' : ''}`}
      style={{ transitionDelay: `${(index % 3) * 90}ms` }}
      data-testid={`ai-card-${feature.id}`}
    >
      <div className="ai-card-icon"><Icon size={24} /></div>
      <h3 className="ai-card-title">{feature.title}</h3>
      <p className="ai-card-desc">{feature.description}</p>
    </article>
  );
}

function PlatformBadges({ badgesRef }) {
  return (
    <div className="ai-badges reveal" ref={badgesRef} data-testid="ai-platforms">
      <span className="ai-badges-label">BUILT WITH THE WORLD'S BEST AI</span>
      <div className="ai-badges-row">
        {AI_PLATFORMS.map((p) => (
          <span key={p} className="ai-badge">{p}</span>
        ))}
      </div>
    </div>
  );
}

export default function AISystems() {
  const headRef = useReveal();
  const badgesRef = useReveal();
  const ctaRef = useReveal();

  const goContact = () => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section className="section ai-section" id="ai" aria-label="AI Systems and Workflow Building" data-testid="ai-section">
      <div className="ai-glow" aria-hidden="true" />
      <div className="section-inner">
        <div className="section-head reveal ai-head" ref={headRef}>
          <span className="section-eyebrow ai-eyebrow">
            <Sparkles size={13} /> NEW MISSION CRITICAL // AI SYSTEMS
          </span>
          <h2 className="section-title">
            PUT <span className="text-pink">AI</span> AT THE HEART OF YOUR BUSINESS
          </h2>
          <p className="section-sub">
            This is the bit that changes everything. We design and build intelligent AI systems
            and automated workflows — powered by <strong>ChatGPT</strong>, <strong>Claude</strong>,{' '}
            <strong>Gemini</strong> and <strong>Emergent</strong> — that answer your customers,
            write your content, run your processes and free your team to do the work that actually matters.
          </p>
        </div>

        <PlatformBadges badgesRef={badgesRef} />

        <div className="ai-grid">
          {AI_FEATURES.map((f, i) => (
            <AICard key={f.id} feature={f} index={i} />
          ))}
        </div>

        <div className="ai-cta reveal" ref={ctaRef}>
          <p className="ai-cta-text">
            Most businesses are sitting on hours of work a week that AI could be doing already.
            Let’s find yours.
          </p>
          <button className="boost-btn boost-btn-primary boost-btn-lg" onClick={goContact} data-testid="ai-cta-button">
            <BrainCircuit size={18} />
            Build My AI System
          </button>
        </div>
      </div>
    </section>
  );
}
